"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOnsitePromotionStencilDefinition = exports.onsitePromotionStencilDefinition = void 0;
const properties_1 = require("../properties");
const associated_assets_property_1 = require("../properties/associated-assets.property");
const bg_hex_color_code_property_1 = require("../properties/bg-hex-color-code.property");
const frequency_cap_property_1 = require("../properties/frequency-cap.property");
const packshot_property_1 = require("../properties/packshot.property");
const promo_type_property_1 = require("../properties/promo-type.property");
const target_tags_property_1 = require("../properties/target-tags.property");
exports.onsitePromotionStencilDefinition = {
    view: {
        label: 'Onsite Promotion',
        group: 'Misc.',
        titleItems: ['title'],
        imageItems: [],
        contentAreas: [
            {
                name: 'main',
                items: [
                    'key-visual',
                    'packshot',
                    'title',
                    'subheading',
                    'legal-disclaimer',
                ],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: [
                            'promo-type',
                            'bg-hex-color-code',
                            'associated-assets',
                            'frequency-cap',
                        ],
                    },
                    {
                        name: 'Targeting',
                        items: ['target-tags', 'excluded-tags'],
                    },
                    {
                        name: 'CTA',
                        items: ['cta-container'],
                    },
                ],
            },
        ],
    },
    content: {
        'associated-assets': associated_assets_property_1.associatedAssetsPropertyDefinition,
        'bg-hex-color-code': bg_hex_color_code_property_1.bgHexColorCodePropertyDefinition,
        'cta-container': properties_1.ctaContainerPropertyDefinition,
        'excluded-tags': properties_1.excludedTagsPropertyDefinition,
        'frequency-cap': frequency_cap_property_1.frequencyCapPropertyDefinition,
        'key-visual': {
            ...properties_1.keyVisualPropertyDefinition,
            view: {
                label: 'Key visual',
                style: 'media-preview',
                hint: 'The image shown in the background of the promo UX.',
            },
        },
        'legal-disclaimer': properties_1.legalDisclaimerPropertyDefinition,
        packshot: packshot_property_1.packshotPropertyDefinition,
        'promo-type': promo_type_property_1.promoTypePropertyDefinition,
        standalone: {
            ...properties_1.standalonePropertyDefinition,
            default: false,
            view: {
                ...properties_1.standalonePropertyDefinition.view,
                readonly: true,
            },
        },
        subheading: properties_1.subheadingPropertyDefinition,
        'target-tags': target_tags_property_1.targetTagsPropertyDefinition,
        title: properties_1.titlePropertyDefinition,
    },
    localizations: [],
    roles: ['onsite-promotion-editor'],
    spaces: ['redbull_com'],
    name: 'onsite-promotion',
};
const isOnsitePromotionStencilDefinition = (stencil) => {
    return stencil.name === exports.onsitePromotionStencilDefinition.name;
};
exports.isOnsitePromotionStencilDefinition = isOnsitePromotionStencilDefinition;
//# sourceMappingURL=data:application/json;base64,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